import React from 'react';
import { ShieldCheck, FileCheck, Info } from 'lucide-react';

/** "Our Certificates" tab: verified KYC docs displayed as image/PDF cards. */
const SupplierCertificatesTab = ({ supplier, certificates }) => (
  <div className="bg-white border border-gray-200 rounded-lg p-6" data-testid="vendor-certs-tab-content">
    <div className="flex items-start justify-between flex-wrap gap-3 mb-5 pb-4 border-b border-gray-100">
      <div>
        <h2 className="text-xl font-bold text-gray-900 flex items-center gap-2">
          <ShieldCheck className="w-6 h-6 text-green-600" /> Our Certificates
        </h2>
        <p className="text-sm text-gray-600 mt-1">
          All certificates shown below have been independently verified by TelanganaMart admins.
        </p>
      </div>
      <span className="inline-flex items-center gap-1 px-3 py-1.5 rounded-full bg-green-100 text-green-800 text-xs font-semibold">
        <ShieldCheck className="w-3.5 h-3.5" /> {certificates.length} verified
      </span>
    </div>

    {certificates.length === 0 ? (
      <div className="py-10 text-center text-gray-500 text-sm">No verified certificates available.</div>
    ) : (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {certificates.map((c) => {
          const abs = c.file_url?.startsWith('http') ? c.file_url : `${process.env.REACT_APP_BACKEND_URL}${c.file_url}`;
          return (
            <a
              key={c.id}
              href={abs}
              target="_blank"
              rel="noopener noreferrer"
              className="group border border-gray-200 rounded-lg overflow-hidden hover:border-[#ee5e23] hover:shadow-md transition bg-white"
              data-testid={`cert-card-${c.id}`}
            >
              <div className="aspect-[4/3] bg-gray-50 flex items-center justify-center overflow-hidden">
                {c.file_ext === 'pdf' ? (
                  <div className="flex flex-col items-center text-red-600">
                    <FileCheck className="w-14 h-14" />
                    <span className="text-[10px] mt-1 font-semibold uppercase">PDF</span>
                  </div>
                ) : (
                  <img src={abs} alt={c.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                )}
              </div>
              <div className="p-3 border-t border-gray-100">
                <div className="flex items-center justify-between gap-2 mb-1">
                  <span className="text-sm font-bold text-gray-900 truncate">{c.cert_type}</span>
                  <span className="inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded text-[10px] font-bold bg-green-100 text-green-800 shrink-0">
                    <ShieldCheck className="w-3 h-3" /> VERIFIED
                  </span>
                </div>
                <div className="text-xs text-gray-600 truncate" title={c.name}>{c.name}</div>
                <div className="text-[11px] text-gray-400 mt-1">Verified on {c.verified_at ? new Date(c.verified_at).toLocaleDateString() : '—'}</div>
              </div>
            </a>
          );
        })}
      </div>
    )}

    <div className="mt-6 pt-4 border-t border-gray-100 text-xs text-gray-500 flex items-start gap-2 bg-blue-50 p-3 rounded">
      <Info className="w-4 h-4 text-blue-600 shrink-0 mt-0.5" />
      <div>
        Need to verify a certificate independently? Switch to the <b>Contact Us</b> tab to view their phone number or send {supplier.name} a message directly.
      </div>
    </div>
  </div>
);

export default SupplierCertificatesTab;
